import React from "react";
import MaterialTable from '@material-table/core';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

function EsmeConnections(props) {
  const rows = props.data.map((row) => {
    return {
      id: row.esme,
      ...row,
    };
  });
  const parents = props.logins.map((row) => {
    return {
      id: row.loginId,
      esme: '',
      ...row,
    };
  });

  return (
    <MaterialTable
      title={
        <Typography component="span" color="textSecondary" gutterBottom>
          <Typography component="span" variant="h5">
            Esme users and connections{" "}
          </Typography>
        </Typography>
      }
      data={rows.concat(parents)}
      columns={[
        { title: "Login", field: "loginId" },
        { title: "Esme", field: "esme" },
        { title: "Ip", field: "ip" },
        { title: "Port", field: "port" },
        { title: "Type", field: "type" },
        { title: "Status", field: "status" }
      ]}
      parentChildData={(row, rows) => rows.find(a => a.loginId === row.esme)}
      options={{
        selection: false,
        pageSizeOptions: [10, 50],
        pageSize: 10
      }}
      components={{
        Container: props => <Paper elevation={0} {...props} />
      }}
    />
  );
}

export default EsmeConnections;
